import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'active-alarms',
  templateUrl: './active-alarms.component.html',
  styleUrls: ['./active-alarms.component.scss']
})
export class ActiveAlarmsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
